export const evaluationsData = [
  {
    id: '0',
    type: 'chat',
    evaluationsType: 'Standard',
    formName: 'QA Form',
    interactionDate: 'Feb 4, 2025 1:13:54 PM',
    duration: '00:00:05',
    evaluationSubject: 'Segment',
    evaluatedOn: 'Feb 4, 2025 1:17:30 PM',
    remainingDays: 'N/A',
    score: '66.67',
    status: 'Completed',
  },
  {
    id: '1',
    type: 'voice',
    evaluationsType: 'Standard',
    formName: 'QA Form',
    interactionDate: 'Dec 2, 2024 11:38:54 PM',
    duration: '00:00:08',
    remainingDays: 'N/A',
    evaluationSubject: 'Segment',
    evaluatedOn: 'Dec 2, 2024 11:40:33 PM',
    score: '66.67',
    status: 'Completed',
  },
];
